import { result } from './ac101-app.js';

export class AC101FiltersButton extends HTMLElement {
  connectedCallback(): void {
    this.addEventListener("click", this._onClick);
  }

  _onClick = (e) => {
    e.preventDefault();

    this.dispatchEvent(
      new CustomEvent("open-filters", {
        detail: { term: result.get()?.name ?? "" },
        bubbles: true,
        composed: true,
      })
    );
  };

}

customElements.define('ac101-filters-button', AC101FiltersButton);

declare global {
  interface HTMLElementTagNameMap {
    "ac101-filters-button": AC101FiltersButton;
  }
}
